import React from 'react'
import { useLanguage } from '../i18n/LanguageContext'
import { trackBookingClick } from '../lib/tracking'

export default function Hero() {
  const { t } = useLanguage()

  return (
    <section className="relative min-h-[86vh] flex flex-col items-center justify-end px-6 md:px-12 lg:px-20 pt-28 pb-16 md:pb-20 overflow-hidden bg-[#10140d]">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
        style={{ filter: 'contrast(1.06) saturate(1.05)' }}
      >
        <source src="https://static.lumi.new/material/ed/ed5424a6e17677e495a7061fd78ca1ec.mp4" type="video/mp4" />
      </video>

      <div className="hero-scrim absolute inset-0" aria-hidden="true" />

      {/* Keyword-rich H1 kept short and high, out of the way of the video subject */}
      <div className="relative z-10 w-full max-w-4xl mx-auto text-center mb-auto pt-2">
        <h1 className="display-heading text-2xl md:text-4xl lg:text-5xl font-extrabold text-white hero-text-shadow leading-tight">
          {t.hero.titleLine1}
          <span className="block text-lg md:text-2xl lg:text-3xl font-semibold mt-1 text-white/90">
            {t.hero.titleLine2}
          </span>
        </h1>
      </div>

      {/* Offer + CTA, positioned low where the MediSpa mark sits in the footage */}
      <div className="relative z-10 max-w-xl mx-auto text-center">
        <div className="hero-offer-pill mb-6 mx-auto">
          <span className="trust-chip !bg-transparent !border-0 !p-0 text-[#c8d4b8] text-xs font-bold uppercase tracking-wide">
            {t.hero.offerEyebrow}
          </span>
          <p className="text-white font-bold text-lg md:text-xl hero-text-shadow leading-snug">
            {t.hero.offerTitle}
          </p>
          <p className="text-white/85 text-sm md:text-base hero-text-shadow">
            {t.hero.offerBody}
          </p>
        </div>

        <div className="button-wrapper inline-block">
          <a
            href="https://medispahr.wixforms.com/f/7479898417246766083"
            target="_blank"
            rel="noopener noreferrer"
            data-cta="book_now"
            data-cta-location="hero"
            onClick={() => trackBookingClick('hero')}
            className="cta-premium guten-button inline-block px-10 py-4 bg-[#768064] text-white text-base font-semibold rounded-full transition-all duration-300 hover:bg-[#5d6950]"
          >
            <span>{t.common.bookConsultation}</span>
          </a>
        </div>

        <p className="text-sm text-white/70 mt-4 hero-text-shadow">
          {t.hero.note}
        </p>
      </div>

      <div className="scroll-cue absolute bottom-6 left-1/2 -translate-x-1/2 z-10" aria-hidden="true">
        <svg className="w-6 h-6 text-white/70" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path strokeLinecap="round" strokeLinejoin="round" d="m19 9-7 7-7-7" />
        </svg>
      </div>
    </section>
  )
}
